import React, { useState, useEffect ,useContext, useMemo} from "react";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { Spacing, Colors, FontSize } from "../../theme/Theme";
import {
  useLocation,
  useHistory,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";
import { RBCardView } from "../../components/RBCardView";
import moment from "moment-timezone";
import { ColumnStyle } from "../../theme/ComponentTheme";
import { RBButton } from "../../components/RBButton";
import { ShiftService } from "../../api/ShiftService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { formatWorkerType } from "../../util/FormattingService";
import {
  detailKmAllowanceIcon,
  detailAccomodationAllowanceIcon,
  techOnSiteIcon,
  assistantOnSiteIcon,
} from "../../util/Icons";
import { Typography, Checkbox, Link,TextField ,InputAdornment} from "@material-ui/core";
import { RoutePathConstant, NotAvailableString, EmptyString, ApprovalModeEnum } from "../../util/Common";
import {
  RenderTextWithTitle,
  titleHeaderTextStyle,
  detailTextStyle,
  renderTextWithTitleAndChildComponent,
  renderTextWithTitleForSkills,
} from "../../components/TextWithHeader";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { LabelText } from "../../util/TextConstant";
import { workerTypeEnum, HelperPageTitleEnum } from "../../util/Enumeration";
import { RBExternalHelpLink } from "../../components/RBExternalHelpLink";
import { AuthService } from "../../api/AuthService";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { RBContext } from '../../components/RBContext';
import {
  evaluateRBPayApplyGate,
  RBPayApplyGateResult,
} from "../../util/rbPay";
import { RBPaySetupRequiredModal } from "./RBPaySetupRequiredModal";
import { ShiftPaymentField } from "../../components/ShiftPayment/ShiftPaymentField";
import { RBPayNotSetupNote } from "../../components/ShiftPayment/RBPayNotSetupNote";
import { PharmacyInformation } from "../shiftDetail/components/PharmacyInformation";
import { RBShiftAgreementModal } from "../../components/RBShiftAgreementModal";
import { RBDropFile } from "../../components/RBDropFile";
import { RBMoneyAmountTextField, RBMoneyAmountTextFieldColor, RBTextField, RBTextFieldColor } from "../../components/RBTextField";
import { IoIosCash } from "react-icons/io";
import { IndustryModeEnum } from "../../api/constants";
import { DentalPracticeInfo } from "../shiftDetail/components/DentalPracticeInfo";
import { RequestedRatetDto } from "../../dtos/RequestedRate.dto";

import { defaultAllowOffersIcon } from '../../components/RBShiftRelatedIcons';
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import PDFViewer from "../../components/PdfViewer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  utcToTimezoneDate,
  timezoneDateToUtc,
  utcToTorontoDate,
  torontoDateToUtc,
  hoursDiff,
  TIMEZONE,
} from "../../util/DatetimeUtils";
import SignaturePad  from "../../components/SignaturePad"
import { getIgnoreWorkerUnavailability } from "../../util/advancedSearchFilters"
import { AccountInfoContext } from "../../components/AccountInfoContext";
interface ApplyShiftPageProps
  extends RouteComponentProps<{ shiftId: string }> {}


  // --- Types ---
interface ShiftRequestFormValues {
  requestedRate: number | "";
  requestedStartTime: string;
  requestedEndTime: string;
  explanation: string;
}

interface ShiftRequestPayload {
  requestedWage?: string;
  requestedStartTime?: string | null;
  requestedEndTime?: string | null;
  explanation?: string | null;
}

// Define the input type
type BidShiftInput =
  | string
  | number
  | {
      requestedWage?: string | number;
      requestedStartTime?: string;
      requestedEndTime?: string;
      explanation?: string;
    };



const ApplyShiftPageWithoutRouter: React.FC<ApplyShiftPageProps> = ({
  match,
}) => {
  const { primaryColor,secondaryColor, industryMode } = useContext(RBContext);
  const location = useLocation<{
    background?: string;
    rbPayApproved?: boolean;
    rbPayStatus?: string | null;
    // US6559 Phase 2 — pushed by the search cards alongside rbPayStatus. paymentType is now
    // the primary driver of isLocationOnRBPay, so the pre-detail-fetch fallback needs it too.
    paymentType?: string | null;
    networkPaid?: boolean | null;
  }>();
  const history = useHistory();
  const [showModal, setShowModal] = useState(true);

  const [searchedShiftDetail, setSearchedShiftDetail] = useState<ObjectLiteral>(
    {}
  );
  const [isLoading, setIsLoading] = useState(true);
  const [agreeTOS, setAgreeTOS] = useState(false);
  const [totalEarning, setTotalEarning] = useState(NotAvailableString);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const [account, setAccount] = useState<any>([]);

  const [showContract,setShowContract] = useState(false);
  const [showTermOfService,setshowTermOfService] = useState(false);
  const [defaultSignature,setDefaultSignature] = useState('');

  const [isNewSignatureAvailable,setIsNewSignatureAvailable] = useState(false);
  const [isDefaultSignatureShown,setIsDefaultSignatureShown] = useState(false);
  const [biddingVisible,setBiddingVisible] = useState(false);
  // US6559 Phase 1 — RB Pay apply gate modal.
  const [rbPayGateOpen, setRbPayGateOpen] = useState(false);
  const [rbPayGate, setRbPayGate] = useState<RBPayApplyGateResult>({
    allow: true,
    modal: "none",
    contactEmail: "",
  });

  // The pharmacy that both the RB Pay apply gate and the Shift Payment field read.
  //
  // Prefers the shift detail response we already fetched (GET shift/:id/potential). Both that
  // endpoint and shift/search/v2 serialise the pharmacy through the SAME PharmacyDto, so the
  // detail copy is not stale, and unlike the router state it survives a browser refresh, a
  // pasted/deep-linked shift URL and the return trip from RB Pay setup. The search card's nav
  // state is kept only as a fallback for the brief window before the detail fetch resolves —
  // it must carry paymentType too, since that is now the primary driver of isLocationOnRBPay.
  const gatePharmacy = searchedShiftDetail?.pharmacy ?? {
    rbPayStatus: location.state?.rbPayStatus ?? null,
    rbPayApproved: location.state?.rbPayApproved === true,
    paymentType: location.state?.paymentType ?? null,
    networkPaid: location.state?.networkPaid ?? null,
  };

  // US6559 Phase 2 — the shift shape the Shift Payment indicator reads. Everything it needs
  // (RB Pay status, payment type, networkPaid, network flags) lives on the pharmacy.
  const paymentShift = { pharmacy: gatePharmacy };
  const [newFile, setNewFile] = useState<File>();
  const [biddingRate,setBiddingRate] = useState('');
  const [wageDisplayValue,setwWgeDisplayValue] = useState<any>(null);
  const [wageRequest,setwageRequest] = useState<any>(" ");
  const [originalWage,setOriginalWage] =useState(" ")

  const[ isWageValid,setIsWageValid] = useState(false);
  const [rateFocused, setRateFocused] = useState(false);
 // track which field was last focused so we don't auto-restore while user types in rate
 const [lastFocusedField, setLastFocusedField] = useState<string | null>(null);
  const [isAlertShowing, setAlertShowing] = useState(false);
  const [applyAlertInfo, setApplyAlertInfo] = useState<AlertInfoProps>({});
  const [errorMessage, setErrorMessage] = useState(EmptyString);
  const [resumeModal, setReumeModal] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selecteEndtDate, setSelectedEndtDate] = useState<Date | null>(null);
  const [minTorontoStartDate, setMinTorontoStartDate] = useState<Date | null>(null);
   const [minTorontoEndDate, setMinTorontoEndDate] = useState<Date | null>(null);
   // validation state for date/time pickers
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);
  const [isDateTimeValid, setIsDateTimeValid] = useState(true);
  //  const [isChanged, setIsChanged] = useState(false);

  // Determine the timezone to use for displaying/converting times for this shift.
  // Prefer the shift's explicit timezone, then the pharmacy/address timezone, then the app default.
  const shiftTimeZone: string =
    (searchedShiftDetail && (searchedShiftDetail.shiftTimeZone || searchedShiftDetail.pharmacy?.address?.timezone)) ||
    TIMEZONE;

  // Store Account Information from AccountInfoContext to use in this page
  const { accountInformation } = useContext(AccountInfoContext);
  useEffect(() => {
    if (accountInformation) {
      setAccount(accountInformation);
      setDefaultSignature(accountInformation.pharmacist.signature);
    }
  }, [accountInformation]);

  useEffect(() => {
    localStorage.removeItem("workerSign")
    fetchShiftDetailByShiftID(match.params.shiftId);
  }, []);
  const fetchShiftDetailByShiftID = async (shiftId: string) => {
    try {
      setIsLoading(true);
      const shiftDetail = await ShiftService.searchShiftDetailById(shiftId);
      console.log("ApplyShiftPage ", shiftDetail);
      setwageRequest((shiftDetail.wage/ 100).toFixed(2))
      setOriginalWage((shiftDetail.wage/ 100).toFixed(2))
      setSearchedShiftDetail(shiftDetail);
      setTotalEarning(ShiftService.getTotalEarningForApplyShift(shiftDetail, account));
    } catch (err) {
      setSubmitErrorMessage(err.message);
    } finally {
      setIsLoading(false);
    }
  };

 
  interface ShiftRequestFormValues {
  requestedRate: string;
  requestedStartTime: string; // UTC string
  requestedEndTime: string;   // UTC string
  explanation: string;
}
  

  //  update when searchedShiftDetail changes
  useEffect(() => {
    if (!searchedShiftDetail?.officialStartTime && !searchedShiftDetail?.officialEndTime ) return;

    const torontoStartDisplayDate = utcToTimezoneDate(searchedShiftDetail.officialStartTime, shiftTimeZone);
  const torontoEndDisplayDate = utcToTimezoneDate(searchedShiftDetail.officialEndTime, shiftTimeZone);
    setSelectedStartDate(torontoStartDisplayDate);
    setSelectedEndtDate(torontoEndDisplayDate)
     setMinTorontoStartDate(torontoStartDisplayDate);
     setMinTorontoEndDate(torontoEndDisplayDate)
  }, [searchedShiftDetail]); // re-run when backend data changes
   // Prepopulate from backend

const initialValues = useMemo(
  () => ({
    // When backend provides wage===0 we want to show "0.00" instead of empty string
    requestedRate:
      searchedShiftDetail && typeof searchedShiftDetail.wage !== "undefined"
        ? (searchedShiftDetail.wage / 100).toFixed(2)
        : "",
    requestedStartTime: searchedShiftDetail?.officialStartTime || "",
    requestedEndTime: searchedShiftDetail?.officialEndTime || "",
    explanation: "",
  }),
  [searchedShiftDetail] //  re-create only when data changes
);

  // --- Validation logic per spec ---

   const validationSchema = Yup.object().shape({
       requestedRate: Yup.number()
   .transform((value, originalValue) => {
     // Support currency-like strings (strip $ and non-number except dot)
     if (typeof originalValue === "string") {
       const cleaned = originalValue.replace(/[^0-9.]/g, "");
       const parsed = parseFloat(cleaned);
       return isNaN(parsed) ? undefined : parsed;
     }
     return value;
   })
  //  .required("Hourly rate is required")
   .min(1, "Hourly rate must be at least $1"),
    requestedStartTime: Yup.string().required(),
    requestedEndTime: Yup.string().required(),
    explanation: Yup.string(),
  });
  // ---- Formik setup ----
  const formik = useFormik({
   enableReinitialize: true,
    initialValues,
    validationSchema,
    validateOnChange: true, 
  validateOnBlur: true,
    validateOnMount: true, // ensure formik.isValid is accurate on mount 
    validate: (values) => {
      const errors: Partial<ShiftRequestFormValues> = {};
      const origStart = moment(searchedShiftDetail.officialStartTime);
      const origEnd = moment(searchedShiftDetail.officialEndTime);
      const reqStart = moment(values.requestedStartTime);
      const reqEnd = moment(values.requestedEndTime);

      // Within ±4 hours of original
      if (hoursDiff(reqStart, origStart) > 4) {
        errors.requestedStartTime = "Start time can only differ by ≤4 hours";
      }
      if (hoursDiff(reqEnd, origEnd) > 4) {
        errors.requestedEndTime = "End time can only differ by ≤4 hours";
      }

      // Shift ≤ 24 hours
      if (reqEnd.diff(reqStart, "hours", true) > 24) {
        errors.requestedEndTime = "Shift duration cannot exceed 24 hours";
      }

      // End after start
      if (reqEnd.isBefore(reqStart)) {
        errors.requestedEndTime = "End time must be after start time";
      }

      return errors;
    },
    onSubmit:(values) => {
  // Convert requestedRate to string with 2 decimals
  
  const requestedWage =
    values.requestedRate !== "" && values.requestedRate != null
      ? parseFloat(values.requestedRate.toString()).toFixed(2)
      : undefined;

  const payload: RequestedRatetDto = {
    requestedWage,                        // string like "25.00"
    requestedStartTime: values.requestedStartTime || undefined,
    requestedEndTime: values.requestedEndTime || undefined,
    explanation: values.explanation?.trim() || undefined,
  };

  // Optional: keep original values for logging or debugging
  const debugPayload = {
    ...payload,
    originalWage: (searchedShiftDetail.wage / 100).toFixed(2),
    originalStartTime: searchedShiftDetail.officialStartTime,
    originalEndTime: searchedShiftDetail.officialEndTime,
  };

  console.log("Payload to send:", debugPayload);

   onBidShift(payload);
 


      // setLoading(true);
    //  try {
    //     const res = await fetch(
    //       `/api/v1/shift/${searchedShiftDetail.id}/request`,
    //       {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify(payload),
    //       } 
    //     );
    //     if (res.ok) {
    //       alert("Request submitted successfully");
    //       onClose();
    //     } else alert("Server rejected request");
    //   } catch (e) {
    //     alert("Network error");
    //   } finally {
    //     setLoading(false);
    //   }
    },
  });


// Track per-field change status
const [fieldChangeStatus, setFieldChangeStatus] = useState({
  rateChanged: false,
  startChanged: false,
  endChanged: false,
  explanationChanged:false,

});

// Dynamic border style helper
const getBorderStyle = (isChanged: boolean) => ({
  border: `2px solid ${isChanged ? "#F57C00" : "rgb(52, 175, 71)"}`, // orange : green
});



// Watch for value changes
useEffect(() => {
  if (!searchedShiftDetail) return;

  setFieldChangeStatus({
    rateChanged:
      formik.values.requestedRate !== (searchedShiftDetail.wage / 100).toFixed(2),

    startChanged:
      normalizeDateForCompare(formik.values.requestedStartTime) !==
      normalizeDateForCompare(searchedShiftDetail.officialStartTime),

    endChanged:
      normalizeDateForCompare(formik.values.requestedEndTime) !==
      normalizeDateForCompare(searchedShiftDetail.officialEndTime),

      explanationChanged:
      (formik.values.explanation || "").trim() !== "",
  });
}, [
  formik.values.requestedRate,
  formik.values.requestedStartTime,
  formik.values.requestedEndTime,
  formik.values.explanation,
  searchedShiftDetail,
]);

// Reset the request modal form state to backend initial values whenever the modal is opened.
// This avoids keeping previously edited but not-submitted values across open/close.
useEffect(() => {
  if (!biddingVisible) return;

  // initialValues is memoized from searchedShiftDetail so it's safe to use here
  try {
    // Reset Formik to initial values from backend
    formik.resetForm({ values: { ...initialValues } });

    // Reset date pickers to Toronto-local equivalents of the initial UTC values
    const startUtc = initialValues.requestedStartTime || searchedShiftDetail?.officialStartTime;
    const endUtc = initialValues.requestedEndTime || searchedShiftDetail?.officialEndTime;

  setSelectedStartDate(startUtc ? utcToTimezoneDate(startUtc, shiftTimeZone) : null);
  setSelectedEndtDate(endUtc ? utcToTimezoneDate(endUtc, shiftTimeZone) : null);

    // Reset local wage state used in bidding UI
    setwageRequest(initialValues.requestedRate ?? "");
    setwWgeDisplayValue(initialValues.requestedRate ?? "0");
    // Special case: when backend wage === 0 we prefixed the field with "0.00"
    // but we don't want to display the validation error / touched state on the
    // first opening of the modal. Clear the touched/error so the red border
    // won't appear until the user interacts.
    if (initialValues.requestedRate === "0.00") {
      try {
        formik.setFieldTouched("requestedRate", false, false);
        formik.setFieldError("requestedRate", undefined);
      } catch (e) {
        // swallow errors to avoid breaking UI
        console.error("Failed to clear initial requestedRate touched/error:", e);
      }
    }
  } catch (e) {
    // swallow to avoid breaking UI (do not throw - will cause white screen)
    console.error("Failed to reset request modal form:", e);
  }
  // run only when modal opens and when initial values change
}, [biddingVisible, initialValues, searchedShiftDetail]);

  const normalizeDateForCompare = (value: string | Date | null | undefined): string => {
  if (!value) return "";

  // Ensure it's a string
  const str = typeof value === "string" ? value : (value as Date).toISOString();

  // Remove milliseconds (the .000 part) and ensure ends with Z
  return str.replace(/\.\d{3}Z$/, "Z");
};


// --- Ensure rate field shows error if user leaves it empty/zero even when component doesn't forward onBlur ---
useEffect(() => {
  // run only when the user is not focused on rate AND they've moved focus elsewhere
  // lastFocusedField is updated by your other field onFocus handlers
  if (rateFocused) return;

  // if lastFocusedField is still null (no interaction) don't validate yet
  if (lastFocusedField === null) return;

  // only validate when the last focus was NOT the rate (i.e. user moved away)
  // or if they explicitly left the rate via the component's onBlur which sets lastFocusedField("rate")
  const rawVal = formik.values.requestedRate ?? "";
  const num = parseFloat(String(rawVal));
  const invalid = rawVal === "" || isNaN(num) || num <= 0;

  if (invalid) {
    // mark touched and set the custom message (keeps Formik state consistent)
    formik.setFieldTouched("requestedRate", true, false);
    formik.setFieldError("requestedRate", "Hourly rate must be at least $1 ");
    setIsWageValid(false);
  } else {
    // clear any previous error
    formik.setFieldError("requestedRate", undefined);
    setIsWageValid(true);
  }
  // only depend on these so it runs when user leaves rate or value changes
}, [lastFocusedField, rateFocused, formik.values.requestedRate]);

  const isChanged =
    formik.values.requestedRate !== (searchedShiftDetail.wage / 100).toFixed(2) ||
 normalizeDateForCompare( formik.values.requestedStartTime) !== normalizeDateForCompare(searchedShiftDetail.officialStartTime) ||
 normalizeDateForCompare( formik.values.requestedEndTime ) !== normalizeDateForCompare( searchedShiftDetail.officialEndTime);

  console.log(`requested rate change -----> ${ formik.values.requestedRate !== (searchedShiftDetail.wage / 100).toFixed(2)}, before => ${(searchedShiftDetail.wage / 100).toFixed(2)} type= ${typeof (searchedShiftDetail.wage / 100).toFixed(2)}, After => ${formik.values.requestedRate} type= ${typeof formik.values.requestedRate}`)
  console.log(`startTime change ---->"${ normalizeDateForCompare( formik.values.requestedStartTime) !== normalizeDateForCompare(searchedShiftDetail.officialStartTime)}, Before =>${normalizeDateForCompare(searchedShiftDetail.officialStartTime) } type =${typeof normalizeDateForCompare(searchedShiftDetail.officialStartTime) } , After =>${normalizeDateForCompare( formik.values.requestedStartTime)} type = ${ typeof normalizeDateForCompare( formik.values.requestedStartTime)}`)
   console.log(`EndTime change ---->"${normalizeDateForCompare( formik.values.requestedEndTime ) !== normalizeDateForCompare( searchedShiftDetail.officialEndTime)}, Before =>${normalizeDateForCompare( searchedShiftDetail.officialEndTime) } type =${typeof normalizeDateForCompare( searchedShiftDetail.officialEndTime) } , After =>${normalizeDateForCompare( formik.values.requestedEndTime )} type = ${ typeof normalizeDateForCompare( formik.values.requestedEndTime )}`)


     // - current rate is empty/invalid
 //  user is NOT actively editing the rate (rateFocused === false)
 //  user is interacting with another field (lastFocusedField !== 'rate')
 //  AND one of the other fields changed vs initial
 useEffect(() => {
   const initialRate = initialValues.requestedRate ?? "";
   if (!initialRate) return;

   // Don't auto-restore while user is actively editing the rate
   if (rateFocused) return;

   const currentRateRaw = formik.values.requestedRate ?? "";
   const currentRateNum = parseFloat(currentRateRaw.toString());
   const isRateEmptyOrInvalid = currentRateRaw === "" || isNaN(currentRateNum) || currentRateNum <= 0;
   if (!isRateEmptyOrInvalid) return; // nothing to restore

   // If last focused field was rate, user just left it — wait until they interact with another field
   if (lastFocusedField === "rate") return;

   const startChanged =
     normalizeDateForCompare(formik.values.requestedStartTime) !== normalizeDateForCompare(initialValues.requestedStartTime);
   const endChanged =
     normalizeDateForCompare(formik.values.requestedEndTime) !== normalizeDateForCompare(initialValues.requestedEndTime);
   const explanationChanged = (formik.values.explanation || "").trim() !== "";

   if ((startChanged || endChanged || explanationChanged)) {
     formik.setFieldValue("requestedRate", initialRate, true);
     setwageRequest(initialRate);
     setIsWageValid(!isNaN(parseFloat(initialRate)) && parseFloat(initialRate) >= 1);
     // clear lastFocusedField so we don't repeatedly try to restore
     setLastFocusedField(null);
   }
 }, [
   formik.values.requestedStartTime,
   formik.values.requestedEndTime,
   formik.values.explanation,
   formik.values.requestedRate,
   rateFocused,
   lastFocusedField,
   initialValues,
 ]);


 const isDataLoading = isLoading || !searchedShiftDetail?.officialStartTime;
console.log("Fetched shiftDetail", searchedShiftDetail);
console.log("Wage source:", searchedShiftDetail?.wage);
  console.log(`RequestedRate value=${formik.values.requestedRate} type ${typeof formik.values.requestedRate}`)

  // ---------------- Toronto min/max logic ----------------
  
  const origStartToronto = searchedShiftDetail?.officialStartTime
    ? utcToTimezoneDate(searchedShiftDetail.officialStartTime, shiftTimeZone)!
    : null;
  const origEndToronto = searchedShiftDetail?.officialEndTime
    ? utcToTimezoneDate(searchedShiftDetail.officialEndTime, shiftTimeZone)!
    : null;
  console.log("origStartToronto------------>",origStartToronto)
  console.log(" origEndToronto------------->",origEndToronto)

  // StartTime picker limits

const origStartTorontoMoment = searchedShiftDetail?.officialStartTime
  ? moment.tz(searchedShiftDetail.officialStartTime, shiftTimeZone)
  : null;
const maxStartTorontoMoment = origStartTorontoMoment ? origStartTorontoMoment.clone().add(4, "hours") : null;



  const minStartTime = origStartToronto;
  // const maxStartTime = moment(origStartToronto).add(4, "hours").toDate();
  const maxStartTime = origStartToronto ? moment(origStartToronto).add(4, "hours").toDate() : undefined;
  const maxStartDate = maxStartTime; // May roll to next day automatically

  // EndTime picker limits

const origEndTorontoMoment = searchedShiftDetail?.officialEndTime
  ? moment.tz(searchedShiftDetail.officialEndTime, shiftTimeZone)
  : null;
const minEndTorontoMoment = origEndTorontoMoment ? origEndTorontoMoment.clone().subtract(4, "hours") : null;

console.log("origEndTorontoMoment ===> ",origEndTorontoMoment?.format())
console.log("minEndTorontoMoment ====> ", minEndTorontoMoment?.format());

  
  const minEndTime = minEndTorontoMoment ? minEndTorontoMoment.toDate() : undefined
  const maxEndTime = origEndTorontoMoment ? origEndTorontoMoment.toDate() : undefined;
 

  const minEndDate = minEndTime; // Handles date roll-back if 4-hour diff crosses day boundary

//new logic for filtertime that exclude selected starttime value

const filterEndTimes = (time: Date) => {
  if (!minEndTorontoMoment || !origEndTorontoMoment || !selectedStartDate) return false;
  // Treat the selected time as Toronto local time
  const t = moment.tz(moment(time).format("YYYY-MM-DD HH:mm:ss"), shiftTimeZone);
  const min = moment(minEndTorontoMoment);
  const max = moment(origEndTorontoMoment);
  // const start = moment.tz(moment(selectedStartDate).format("YYYY-MM-DD HH:mm:ss"), "America/Toronto");
  const start = moment.tz(moment(selectedStartDate).format("YYYY-MM-DD HH:mm:ss"), shiftTimeZone);
  // console.log("startvalue @ filterEndTimes->",start) // current selected start time

  // Check if range crosses midnight
  const crossesMidnight = max.isBefore(min);

  let withinRange = false;

  if (crossesMidnight) {
    // Case: range like Oct 30 8:45 PM → Oct 31 12:45 AM
    withinRange = t.isSameOrAfter(min) || t.isSameOrBefore(max);
  } else {
    // Normal case (same-day range)
    withinRange = t.isSameOrAfter(min) && t.isSameOrBefore(max);
  }

  // New condition: block times that are before or equal to start time
  const afterStart = t.isAfter(start);

  // Final condition
  return withinRange && afterStart;
};


const filterStartTimes = (time: Date) => {
  if (!origStartTorontoMoment || !maxStartTorontoMoment || !selecteEndtDate) return false;
  // Interpret the DatePicker value as Toronto local time
  const t = moment.tz(moment(time).format("YYYY-MM-DD HH:mm:ss"), shiftTimeZone);

  const start = moment(origStartTorontoMoment);   // Lower bound
  const end = moment(maxStartTorontoMoment);      // Upper bound
  const selectedEnd = moment.tz(moment(selecteEndtDate).format("YYYY-MM-DD HH:mm:ss"), shiftTimeZone);
  // console.log("startvalue @ filterEndTimes->",start) // current selected start time     // Currently selected end time

  const crossesMidnight = end.isBefore(start);

  let withinRange = false;

  if (crossesMidnight) {
    // Case: range spans over midnight
    // e.g. Oct 30 20:00 → Oct 31 02:00
    withinRange = t.isSameOrAfter(start) || t.isSameOrBefore(end);
  } else {
    // Normal same-day range
    withinRange = t.isSameOrAfter(start) && t.isSameOrBefore(end);
  }

  // New logic: block start times that are equal or after selected end time
  const beforeEnd = t.isBefore(selectedEnd);

  // Final condition
  return withinRange && beforeEnd;
};


// new: validate selected start/end date+time so we never send an out-of-range combination
useEffect(() => {
  // Only validate when we have the required moments and at least one selected date
  if (!origStartTorontoMoment || !origEndTorontoMoment) return;

  // if no selection yet, clear errors
  if (!selectedStartDate && !selecteEndtDate) {
    setStartDateError(null);
    setEndDateError(null);
    setIsDateTimeValid(true);
    return;
  }

  const formatKey = "YYYY-MM-DD HH:mm:ss";
  const torStart = selectedStartDate
    ? moment.tz(moment(selectedStartDate).format(formatKey), shiftTimeZone)
    : null;
  const torEnd = selecteEndtDate
    ? moment.tz(moment(selecteEndtDate).format(formatKey), shiftTimeZone)
    : null;

  const minStart = origStartTorontoMoment.clone();
  const maxStart = maxStartTorontoMoment?.clone();
  const minEnd = minEndTorontoMoment?.clone();
  const maxEnd = origEndTorontoMoment.clone();

  let sError: string | null = null;
  let eError: string | null = null;

  if (torStart) {
    // start must be within [minStart, maxStart]
    if (!(torStart.isSameOrAfter(minStart) && torStart.isSameOrBefore(maxStart))) {
      // sError = `Invalid start time. Must be between ${minStart.format("eee, MMM do yyyy h:mm a")} and ${maxStart?.format("eee, MMM do yyyy h:mm a")}.`;
      sError = `Please enter a valid start date!`
    }
    }

  if (torEnd) {
    // end must be within [minEnd, maxEnd]
    if (!(torEnd.isSameOrAfter(minEnd) && torEnd.isSameOrBefore(maxEnd))) {
      // eError = `Invalid end time. Must be between ${minEnd?.format("eee, MMM do yyyy h:mm a")} and ${maxEnd.format("eee, MMM do yyyy h:mm a")}.`;
      eError=`Please enter a valid end date!`
    }
  }

  // If both present, ensure end > start
  if (!sError && !eError && torStart && torEnd) {
    if (!torEnd.isAfter(torStart)) {
      eError = "End time must be after start time.";
    }
  }

  setStartDateError(sError);
  setEndDateError(eError);
  setIsDateTimeValid(!sError && !eError);
}, [
  selectedStartDate,
  selecteEndtDate,
  origStartTorontoMoment,
  maxStartTorontoMoment,
  origEndTorontoMoment,
  minEndTorontoMoment,
]);

 // --- Shared DatePicker style (error highlight) ---
  const datePickerStyle = (hasError?: boolean): React.CSSProperties => ({
    width: 260,
    borderRadius: 6,
    padding: "8px 10px",
    border: hasError ? "1px solid red" : "1px solid #ccc",
  });


  // Utility function to mask sensitive info

const maskSensitiveInfo = (text: string): string => {
  // Mask any pattern that contains 10+ digits, ignoring spaces, dashes, parentheses, or dots between them
  let masked = text.replace(
    /(?:(?:\+?\d[\s\-\(\)\.]*){10,})/g,
    "**********"
  );

  // Mask email addresses
  masked = masked.replace(
    /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g,
    "***@********.***"
  );

  return masked;
};

  const setShowTermOfService = (showTermOfService:boolean) =>
  setshowTermOfService(showTermOfService);


  const onTermsClose = () =>{
    setshowTermOfService(false);
  }
  const onResumeClose= () => {
    setReumeModal(false)
   };

  const renderKMAllowance = (primaryColor:string) => {
    const { kmAllowance } = searchedShiftDetail;
    return (
      <div style={{ flex: 1, alignItems: "flex-start" }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
            ...titleHeaderTextStyle,
          }}
        >
          {detailKmAllowanceIcon(primaryColor)}
          <div
            style={{
              marginLeft: Spacing.smallest,
            }}
          >
            KM Allowance
          </div>
        </div>

        <div style={detailTextStyle}>
          {"$" + (kmAllowance / 100).toFixed(2) + "/km"}
        </div>
      </div>
    );
  };
  const   checkForm = (wage:any) => {
    if(wage !== null){
      return !(
        agreeTOS &&
        (newFile || defaultSignature) &&   wage !== "0.00"
      );
    }
    else{
      return !(
        agreeTOS &&
        (newFile || defaultSignature)
      );
    }
    
  };

  const renderAccomodationAllowance = () => {
    const { accomodationAllowance } = searchedShiftDetail;
    return (
      <div style={{ flex: 1, alignItems: "flex-start" }}>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            alignItems: "center",
            ...titleHeaderTextStyle,
          }}
        >
          {detailAccomodationAllowanceIcon(primaryColor)}
          <div
            style={{
              marginLeft: Spacing.smallest,
            }}
          >
            Allowance
          </div>
        </div>

        <div style={detailTextStyle}>
          {"$" + (accomodationAllowance / 100).toFixed(2)}
        </div>
      </div>
    );
  };

  const renderSearchedShiftDetail = () => {
    const startTime = moment(searchedShiftDetail.startTime).tz(
      searchedShiftDetail.shiftTimeZone
    );
    const endTime = moment(searchedShiftDetail.endTime).tz(
      searchedShiftDetail.shiftTimeZone
    );
    const startTimeFormat = startTime ? startTime.format("h:mm a") : "N/A";
    const endTimeFormat = endTime ? endTime.format("h:mm a") : "N/A";
    const hoursDisplay = ShiftService.getShiftLengthDisplayForOriginal(
      searchedShiftDetail
    );
    const dateString = moment(searchedShiftDetail.startTime).format(
      "ddd, MMM Do YYYY"
    );
    const wage =
    searchedShiftDetail.actualCommission !== undefined && searchedShiftDetail.actualCommission !== null ? (searchedShiftDetail.wage/ 100).toFixed(2) :(ShiftService.getWage(searchedShiftDetail, account) / 100).toFixed(2);
      console.log("wage",wage)
    const shiftDistance = Math.round(searchedShiftDetail.distance / 1000);
    const shiftCity = searchedShiftDetail.shiftCity;
   
    const rxCount = searchedShiftDetail.expectedRxCount
      ? searchedShiftDetail.expectedRxCount
      : NotAvailableString;

    const kmAllowance = (searchedShiftDetail.kmAllowance / 100).toFixed(2);
    const accomodationAllowance = (
      searchedShiftDetail.accomodationAllowance / 100
    ).toFixed(2);
    const kmAllowanceAvailable = kmAllowance !== "0.00";
    const accomodationAllowanceAvailable = accomodationAllowance !== "0.00";

    console.log("apply shift ", kmAllowance, accomodationAllowance);
    const workerType = searchedShiftDetail.pharmacistType;
    const techOnSite = searchedShiftDetail.technicianOnSite;
    const assistOnSite = searchedShiftDetail.assistantOnSite;
    const comment = searchedShiftDetail.comment
      ? searchedShiftDetail.comment
      : NotAvailableString;
    const signature = account.pharmacist.signature;
    const dentalType =  searchedShiftDetail.dentalType;

    const { shiftSkillSets, locationSkillSets } = searchedShiftDetail.pharmacy.network.skillSet;
    const skills =  searchedShiftDetail.skills;

  const skillsByType:any = {};
    skills.forEach((skill:any) => {
      if (!skillsByType[skill.type]) {
        skillsByType[skill.type] = [];
      }
      skillsByType[skill.type].push(skill);
    });

    // Extract location skills and shift skills separately
    const locationSkillsByType:any = {};
    locationSkillSets.forEach((type:any) => {
      locationSkillsByType[type] = skillsByType[type] || [];
    });
    console.log("locationSkillsByType",locationSkillsByType)

    const shiftSkillsByType:any = {};
    shiftSkillSets.forEach((type:any) => {
      shiftSkillsByType[type] = skillsByType[type] || [];
    });

    const capitalize = (str:any) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const contractPreviewClick = () =>{
      setShowContract(true);
    }

    const onContractClose = () =>{
      setShowContract(false);
    }
    const currentDate = moment().format('MMM-DD-YYYY');
    const currentYear = moment().year();
    const pharmacistDetails =
      account.pharmacist.firstName + ' ' + account.pharmacist.lastName;
    const DATE_FORMAT = 'MMM-DD-YYYY h:mm a';
    let associationFlag = false;
    let associationName = null;
    if(account?.userAssociationMember && account.userAssociationMember.length >0){
      associationFlag = true;
      associationName = account.userAssociationMember[0].association.associationName;
    }

    return (
      <>
        <RBAlert
          show={isAlertShowing}
          alertTitle={applyAlertInfo.title}
          alertMessage={applyAlertInfo.message}
          buttons={applyAlertInfo.buttons}
        />

        {showContract && <RBShiftAgreementModal
          open={showContract}
          onClose={onContractClose}
          modalTitle="Shift Contract"
          pageName="contract-pharmacist"
          pageType="page"
          networkId = {searchedShiftDetail.pharmacy.networkId}
          shiftId = {searchedShiftDetail.id}
          userId= { account.id }
          type = 'shift'
          substitutions={{
            currentDate,
            currentYear,
            endTime: moment(endTime).format(DATE_FORMAT),
            pharmacistDetails: pharmacistDetails,
            pharmacyDetails: '[Pharmacy]',
            shiftNumber: `xxxx-${currentYear}-x-xx`,
            startTime: moment(startTime).format(DATE_FORMAT),
            wage: `$${wage}/hr`,
            pharmacistSignature: '',
            pharmacySignature: '',
            licenseNumber: '',
            accredidationNumber: '',
            pharmacistName: pharmacistDetails,
            reliefBuddySignature: '',
            workerType: formatWorkerType(workerType),
            kmAllowance: kmAllowanceAvailable ? `$${kmAllowance}` : 0,
            accomodationAllowance: accomodationAllowanceAvailable
              ? `$${accomodationAllowance}`
              : 0,
          }}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
        />}
        {
        (industryMode === IndustryModeEnum.Dentistry ||  industryMode === IndustryModeEnum.Labour) ? 
            (<>
              <RBCardView
                marginHorizontal={Spacing.large}
                style={{
                  padding: Spacing.large,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DentalPracticeInfo
                  pharmacy={searchedShiftDetail.pharmacy}
                  shiftData={searchedShiftDetail}
                  owner={false}
                  ownerEmail={''}
                  showPartialInfo={false}
                  account={account}
                  page="applyShift"
                />
              </RBCardView>
              <br></br>
              <RBCardView
                marginHorizontal={Spacing.large}
                style={{
                  padding: Spacing.large,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={ColumnStyle}>
                  {RenderTextWithTitle(industryMode === IndustryModeEnum.Dentistry ?  "Practice Type" : "Company Type", dentalType)}
                </div>

                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Shift", searchedShiftDetail.shiftNumber)}
                  {RenderTextWithTitle("Worker Type", formatWorkerType(workerType))}
                </div>

                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Date", dateString)}
                  {RenderTextWithTitle("Time", `${startTimeFormat} - ${endTimeFormat}`)}
                </div>
               
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Duration", hoursDisplay)}
                  {RenderTextWithTitle(`Distance ${!kmAllowanceAvailable ? ' (Est.)':'' }`, shiftDistance + "km")}
                </div>

                {(kmAllowanceAvailable || accomodationAllowanceAvailable) && (
                  <div style={ColumnStyle}>
                    {kmAllowanceAvailable && renderKMAllowance(primaryColor)}
                    {accomodationAllowanceAvailable && renderAccomodationAllowance()}
                  </div>
                )}

                {(locationSkillSets.length === 1 && shiftSkillSets.length === 1) ?
                  <div style={ColumnStyle}>
                    {renderTextWithTitleForSkills(
                      capitalize(locationSkillSets[0]),
                      (locationSkillsByType[locationSkillSets[0]] || []).map((skill: any) =>
                        skill.required
                          ? skill.name
                          : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
                      )
                    )}
                    {renderTextWithTitleForSkills(
                      capitalize(shiftSkillSets[0]),
                      (shiftSkillsByType[shiftSkillSets[0]] || []).map((skill: any) => skill.name)
                    )}
                  </div> :
                  <>
                    {Object.entries(locationSkillsByType).map(([type, skills]) => {
                      const skillsArray = skills as any[]; // or use a more specific type if you have one

                      return skillsArray.length > 0 ? (
                        <div style={ColumnStyle}>
                          {renderTextWithTitleForSkills(
                            capitalize(type),
                            skillsArray.map((skill: any) =>
                              skill.required
                                ? skill.name
                                : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
                            )
                          )}
                        </div>
                      ) : null;
                    })}
                    {Object.entries(shiftSkillsByType).map(([type, skills]) => {
                      const skillsArray = skills as any[];
                      return (
                        <div style={ColumnStyle}>
                          {renderTextWithTitleForSkills(
                            capitalize(type),
                            skillsArray.length > 0 ? skillsArray.map((skill: any) => skill.name) : [] // always pass an array
                          )}
                        </div>
                      );
                    })}
                  </>


                }      
                {/* US6559 Phase 2 — how this shift gets paid, shown before the worker applies. */}
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Comment", comment)}
                  <ShiftPaymentField shift={paymentShift} />
                </div>

                {defaultSignature ?
                  <div style={ColumnStyle}>
                    {renderTextWithTitleAndChildComponent("Signature", <Link
                      //href={signature}
                      onClick={() => setReumeModal(true)}
                      style={{ ...detailTextStyle, color: primaryColor, cursor: 'pointer' }}
                    >
                      {"View"}
                    </Link>)
                    }
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        overflowWrap: "anywhere",
                        alignItems: "flex-start",
                        alignContent: "flex-start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          overflowWrap: "anywhere",

                          ...titleHeaderTextStyle,
                        }}
                      >
                        Shift Agreement
                      </div>

                      <Link
                        style={{
                          display: "flex",
                          flex: 1,
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                          ...detailTextStyle,
                          color: primaryColor,
                          cursor: 'pointer'
                        }}
                        onClick={contractPreviewClick}
                      >
                        Preview
                      </Link>
                    </div>
                  </div>
                  :
                  (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          flexDirection: "column",
                          overflowWrap: "anywhere",
                          alignItems: "flex-start",
                          alignContent: "flex-start",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            overflowWrap: "anywhere",

                            ...titleHeaderTextStyle,
                          }}
                        >
                          Shift Agreement
                        </div>

                        <Link
                          style={{
                            display: "flex",
                            flex: 1,
                            whiteSpace: "pre-wrap",
                            overflowWrap: "anywhere",
                            ...detailTextStyle,
                            color: primaryColor,
                            cursor: 'pointer'
                          }}
                          onClick={contractPreviewClick}
                        >
                          Preview
                        </Link>
                      </div>

                      <SignaturePad
                        isVisible={true}
                        onLoad = {(file,dataURL) =>{
                          setNewFile(file)
                        }}

                        onSave={(file,dataURL) =>{
                        }}
                        onCancel={() =>{}}
                        onClear={() => {
                          localStorage.removeItem("workerSign")
                          setNewFile(undefined)
                        }}
                        userData = {account.pharmacist}
                        page="applyShift"
                      />
                      
                      <div style={{ fontSize: 10 }}>
                        *This signature will be saved in your profile as default for
                        future usage
                      </div>
                    </>

                  )
                }

                {(wage !== "0.00") &&
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: Spacing.large,
                    }}
                  >
                    <Checkbox
                      checked={agreeTOS}
                      style={{
                        padding: 0,
                        paddingRight: Spacing.large,
                        // Why marginLeft -2, so  it will align with regular label or text field
                        marginLeft: -2,
                        color: agreeTOS ? secondaryColor : Colors.darkGrey,
                      }}
                      onChange={(_, checked) => {
                        setAgreeTOS(checked);
                      }}
                    />
                    <Typography variant="body2">
                      I have read and understood the{" "}

                      <Link onClick={() => setShowTermOfService(true)} style={{ color: primaryColor, cursor: 'pointer',fontWeight:"bold" }}>{HelperPageTitleEnum.termOfService}
                        .</Link>
                    </Typography>
                  </div>
                }
                {(searchedShiftDetail.allowOffers && wage === "0.00") &&
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: Spacing.large,
                    }}
                  >
                    <Checkbox
                      checked={agreeTOS}
                      style={{
                        padding: 0,
                        paddingRight: Spacing.large,
                        // Why marginLeft -2, so  it will align with regular label or text field
                        marginLeft: -2,
                        color: agreeTOS ? secondaryColor : Colors.darkGrey,
                      }}
                      onChange={(_, checked) => {
                        setAgreeTOS(checked);
                      }}
                    />
                    <Typography variant="body2">
                      I have read and understood the{" "}

                      <Link onClick={() => setShowTermOfService(true)} style={{ color: primaryColor, cursor: 'pointer',fontWeight:"bold" }}>{HelperPageTitleEnum.termOfService}
                        .</Link>
                    </Typography>
                  </div>
                }
                {showTermOfService && <RBShiftAgreementModal
                  open={showTermOfService}
                  onClose={onTermsClose}
                  modalTitle={"Terms of Service"}
                  pageName="terms-of-use"
                  pageType="page"
                  networkId={searchedShiftDetail.pharmacy.networkId}
                  header={
                    <RBEmptyBlock
                      style={{
                        width: "100%",
                        height: Spacing.large,
                        backgroundColor: Colors.defaultGrey,
                        flexShrink: 0,
                      }}
                    />
                  }
                />
                }

                {/*
                  US6559 Phase 2 — replaces the popup we previously planned for "office not on
                  RB Pay". Sits between the Terms of Service checkbox and the Apply CTAs, per
                  the client mockup.
                */}
                <RBPayNotSetupNote
                  shift={paymentShift}
                  style={{ marginTop: Spacing.large }}
                />

                  {!searchedShiftDetail.allowOffers && wage!="0.00" && <>
                  
                   <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >

                  <RBButton
                    style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                        marginBottom: 16,
                        marginTop: 16
                      }}
                    buttonBackgroundColor={primaryColor}
                    onClick={() => guardApply(onSubmit)}
                    isLoading={isSubmitting}
                    disabled={checkForm(wage) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                    text={`Total : $${totalEarning}  |  Apply`}
                  />
                </div>
                 <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >
                   <RBButton
                      style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                        marginBottom: wage === "0.00" ? 16 : 0,
                        marginTop:  wage === "0.00" ? 16 : 0
                      }}
                      buttonBackgroundColor={secondaryColor}
                      onClick={() => guardApply(() => setBiddingVisible(true))}
                      isLoading={isSubmitting}
                      disabled={checkForm(null)}
                      text={`Request Change`}
                    />
                    </div>
                </>}
                
                
                {searchedShiftDetail.allowOffers && <>
                  {wage!="0.00" && 
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        alignItems: "flex-end",
                      }}
                    >
                      <RBButton
                        style={{
                          display: "flex",
                          flex: 1,
                          padding: Spacing.medium,
                          marginBottom: 16,
                          marginTop: 16
                        }}
                        buttonBackgroundColor={primaryColor}
                        onClick={() => guardApply(() => onBidShift(wage))}
                        isLoading={isSubmitting}
                        disabled={checkForm(wage) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                        text={`Total : $${totalEarning}  |   Apply Now ($${wage}/hr)`}
                      />
                    </div>
                  }
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "flex-end",
                    }}
                  >
                    <RBButton
                      style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                        marginBottom: wage === "0.00" ? 16 : 0,
                        marginTop:  wage === "0.00" ? 16 : 0
                      }}
                      buttonBackgroundColor={secondaryColor}
                      onClick={() => guardApply(() => setBiddingVisible(true))}
                      isLoading={isSubmitting}
                      disabled={checkForm(null) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                      text={`Request Rate & Apply`}
                    />
                  </div>
                </>
                }
              </RBCardView>
            </>) :

            <>
              <RBCardView
                marginHorizontal={Spacing.large}
                style={{
                  padding: Spacing.large,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <PharmacyInformation
                  shiftData={searchedShiftDetail}
                  pharmacy={searchedShiftDetail.pharmacy}
                  owner={false}
                  showPartialInfo={true}
                  account={account}
                  page="applyShift"
                />
              </RBCardView>
              <br></br>
              <RBCardView
                marginHorizontal={Spacing.large}
                style={{
                  padding: Spacing.large,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                 <div style={ColumnStyle}>
                  {RenderTextWithTitle("Shift", searchedShiftDetail.shiftNumber)}
                  {RenderTextWithTitle("Worker Type", formatWorkerType(workerType))}
                </div>
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Date", dateString)}
                  {RenderTextWithTitle("Time", `${startTimeFormat} - ${endTimeFormat}`)}
                </div>
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Duration", hoursDisplay)}
                 
                   <div style={{ flex: 1, alignItems: "flex-start" }}>
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        ...titleHeaderTextStyle,
                      }}
                    >

                      <div
                        style={{
                          marginLeft: Spacing.smallest,
                        }}
                      >
                        Hourly Rate
                      </div>
                      {searchedShiftDetail.allowOffers && defaultAllowOffersIcon(secondaryColor)}
                    </div>


                    <div style={{...detailTextStyle,
                       color: Number(wage) === 0 ? secondaryColor : undefined,
                    }}>
                      {Number(wage) === 0 ? "Open Offer" : `$${Number(wage)}`}
                      {/* {"$" + wage} */}
                    </div>

                  </div>
                </div>

                {(kmAllowanceAvailable || accomodationAllowanceAvailable) && (
                  <div style={ColumnStyle}>
                    {kmAllowanceAvailable && renderKMAllowance(primaryColor)}
                    {accomodationAllowanceAvailable && renderAccomodationAllowance()}
                  </div>
                )}


                {associationFlag && <div
                  style={{
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    borderWidth: 1,
                    borderColor: "red",

                  }}
                >
                  <div style={{ flex: 1, alignItems: 'flex-start' }}>
                    <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: Spacing.medium,
                        color: 'red',
                      }}
                    >
                      *The Hourly Rate excludes your {associationName} membership benefit which is added upon shift completion.
                    </div>
                  </div>
                </div>
                }



                <div style={ColumnStyle}>
                  {RenderTextWithTitle("City", shiftCity)}
                  {RenderTextWithTitle(`Distance ${!kmAllowanceAvailable ? ' (Est.)':'' }`, shiftDistance + "km")}
                </div>

                <div style={ColumnStyle}>
                  {renderTextWithTitleAndChildComponent(
                    LabelText.TECHNICIAN_ON_SITE,
                    techOnSiteIcon(techOnSite, secondaryColor)
                  )}
                  {workerType !== workerTypeEnum.assistant &&
                    renderTextWithTitleAndChildComponent(
                      LabelText.ASSISTANT_ON_SITE,
                      assistantOnSiteIcon(assistOnSite, secondaryColor)
                    )}
                </div>

                {(locationSkillSets.length === 1 && shiftSkillSets.length === 1) ?
                  <div style={ColumnStyle}>
                    {renderTextWithTitleForSkills(
                      capitalize(locationSkillSets[0]),
                      (locationSkillsByType[locationSkillSets[0]] || []).map((skill: any) =>
                        skill.required
                          ? skill.name
                          : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
                      )
                    )}
                    {renderTextWithTitleForSkills(
                      capitalize(shiftSkillSets[0]),
                      (shiftSkillsByType[shiftSkillSets[0]] || []).map((skill: any) => skill.name)
                    )}
                  </div> :
                  <>
                    {Object.entries(locationSkillsByType).map(([type, skills]) => {
                      const skillsArray = skills as any[]; // or use a more specific type if you have one

                      return skillsArray.length > 0 ? (
                        <div style={ColumnStyle}>
                          {renderTextWithTitleForSkills(
                           capitalize(type),
                            skillsArray.map((skill: any) =>
                              skill.required
                                ? skill.name
                                : ShiftService.getUnrequiredSoftwareName?.(skill.name) || skill.name
                            )
                          )}
                        </div>
                      ) : null;
                    })}
                    {Object.entries(shiftSkillsByType).map(([type, skills]) => {
                      const skillsArray = skills as any[];
                      return (
                        <div style={ColumnStyle}>
                          {renderTextWithTitleForSkills(
                            capitalize(type),
                            skillsArray.length > 0 ? skillsArray.map((skill: any) => skill.name) : [] // always pass an array
                          )}
                        </div>
                      );

                    })}
                  </>


                }      
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Daily Avg Rx Count", rxCount)}
                </div>
                {/* US6559 Phase 2 — how this shift gets paid, shown before the worker applies. */}
                <div style={ColumnStyle}>
                  {RenderTextWithTitle("Comment", comment)}
                  <ShiftPaymentField shift={paymentShift} />
                </div>


                {defaultSignature ?
                  <div style={ColumnStyle}>
                    {renderTextWithTitleAndChildComponent("Signature", <Link
                      // href={signature}
                      onClick={() => setReumeModal(true)}
                      style={{ ...detailTextStyle, color: primaryColor, cursor: 'pointer' }}
                    >
                      {"View"}
                    </Link>)
                    }
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        overflowWrap: "anywhere",
                        alignItems: "flex-start",
                        alignContent: "flex-start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          overflowWrap: "anywhere",

                          ...titleHeaderTextStyle,
                        }}
                      >
                        Shift Agreement
                      </div>

                      <Link
                        style={{
                          display: "flex",
                          flex: 1,
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                          ...detailTextStyle,
                          color: primaryColor,
                          cursor: 'pointer'
                        }}
                        onClick={contractPreviewClick}
                      >
                        Preview
                      </Link>
                    </div>
                  </div>
                  :
                  (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flex: 1,
                          flexDirection: "column",
                          overflowWrap: "anywhere",
                          alignItems: "flex-start",
                          alignContent: "flex-start",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            overflowWrap: "anywhere",

                            ...titleHeaderTextStyle,
                          }}
                        >
                          Shift Agreement
                        </div>

                        <Link
                          style={{
                            display: "flex",
                            flex: 1,
                            whiteSpace: "pre-wrap",
                            overflowWrap: "anywhere",
                            ...detailTextStyle,
                            color: primaryColor,
                            cursor: 'pointer'
                          }}
                          onClick={contractPreviewClick}
                        >
                          Preview
                        </Link>
                      </div>

                      <SignaturePad
                        isVisible={true}
                        onLoad = {(file,dataURL) =>{
                          setNewFile(file)
                        }}

                        onSave={(file,dataURL) =>{
                        }}
                        onCancel={() =>{}}
                        onClear={() => {
                          localStorage.removeItem("workerSign")
                          setNewFile(undefined)
                        }}
                        userData = {account.pharmacist}
                        page="applyShift"
                      />
                      
                      <div style={{ fontSize: 10 }}>
                        *This signature will be saved in your profile as default for
                        future usage
                      </div>
                    </>

                  )
                }


                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: Spacing.large,
                  }}
                >
                  <Checkbox
                    checked={agreeTOS}
                    style={{
                      padding: 0,
                      paddingRight: Spacing.large,
                      // Why marginLeft -2, so  it will align with regular label or text field
                      marginLeft: -2,
                      color: agreeTOS ? secondaryColor : Colors.darkGrey,
                    }}
                    onChange={(_, checked) => {
                      setAgreeTOS(checked);
                    }}
                  />
                  <Typography variant="body2">
                    I have read and understood the{" "}

                    <Link onClick={() => setShowTermOfService(true)} style={{ color: primaryColor, cursor: 'pointer',fontWeight:"bold" }}>{HelperPageTitleEnum.termOfService}
                      .</Link>
                  </Typography>
                </div>
                {showTermOfService && <RBShiftAgreementModal
                  open={showTermOfService}
                  onClose={onTermsClose}
                  modalTitle={"Terms of Service"}
                  pageName="terms-of-use"
                  pageType="page"
                  networkId={searchedShiftDetail.pharmacy.networkId}
                  header={
                    <RBEmptyBlock
                      style={{
                        width: "100%",
                        height: Spacing.large,
                        backgroundColor: Colors.defaultGrey,
                        flexShrink: 0,
                      }}
                    />
                  }
                />
                }

                {/* US6559 Phase 2 — see the other branch above for the placement rationale. */}
                <RBPayNotSetupNote
                  shift={paymentShift}
                  style={{ marginTop: Spacing.large }}
                />

                  {!searchedShiftDetail.allowOffers && <>
                  <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >
                  <RBButton
                   style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                        marginBottom: 16,
                        marginTop: 16
                      }}
                    buttonBackgroundColor={primaryColor}
                    onClick={() => guardApply(onSubmit)}
                    isLoading={isSubmitting}
                    disabled={checkForm(wage) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                    text={`Total : $${totalEarning}  |  Apply`}
                  />
                  </div>
                   <div
                  style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-end",
                  }}
                >

                   <RBButton
                      style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                      }}
                      buttonBackgroundColor={secondaryColor}
                      onClick={() => guardApply(() => setBiddingVisible(true))}
                      isLoading={isSubmitting}
                      disabled={checkForm(null)}
                      text={`Request Change`}
                    />
                    </div>

                  </>

                 
                  }
                

                {searchedShiftDetail.allowOffers && <>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "flex-end",
                    }}
                  >
                    <RBButton
                      style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                        marginBottom: 16,
                        marginTop: 16
                      }}
                      buttonBackgroundColor={primaryColor}
                      onClick={() => guardApply(() => onBidShift(wage))}
                      isLoading={isSubmitting}
                      disabled={checkForm(wage) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold }
                      text={`Total : $${totalEarning}  |   Apply Now ($${wage}/hr)`}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "flex-end",
                    }}
                  >
                    <RBButton
                      style={{
                        display: "flex",
                        flex: 1,
                        padding: Spacing.medium,
                      }}
                      buttonBackgroundColor={secondaryColor}
                      onClick={() => guardApply(() => setBiddingVisible(true))}
                      isLoading={isSubmitting}
                      disabled={checkForm(null) || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
                      text={`Request Rate & Apply`}
                    />
                  </div>
                </>
                }




              </RBCardView>
            </>
        }
      </>
    );
  };

  // US6559 Phase 1 — RB Pay apply gate. Runs at every Apply CTA. If the worker may
  // apply, `proceed` runs as-is; otherwise the appropriate gate modal is shown and
  // the apply is not started.
  const guardApply = (proceed: () => void) => {
    const gate = evaluateRBPayApplyGate({
      account,
      pharmacy: gatePharmacy,
      industryMode,
      roleName: account?.roleName,
    });
    if (gate.allow) {
      proceed();
      return;
    }
    setRbPayGate(gate);
    setRbPayGateOpen(true);
  };

  const goToRBPaySetup = () => {
    setRbPayGateOpen(false);
    // Pass the current shift URL so RB Pay setup can return here on completion
    // (RBPaySettings honours location.state.from; other entry points fall back to
    // the dashboard).
    history.push(RoutePathConstant.RBPaySettings, {
      from: history.location.pathname,
    });
  };

  const onSubmit = async () => {
    try {
      setIsSubmitting(true);
      await createApplication();
    } catch (err) {
      const errorMessage = err.response ? err.response.data.error : err.message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };
  //New onBidShift------------------------

 const onBidShift = async (input: BidShiftInput) => {
  try {
    setIsSubmitting(true);

    let payload: ShiftRequestPayload = {};

    if (typeof input === "string" || typeof input === "number") {
      // convert number to string for parseFloat safely
      const wageString = input.toString();
      payload = { requestedWage: (parseFloat(wageString) * 100).toFixed(2) };
      
    } else if (typeof input === "object" && input !== null) {
      const wageString = input.requestedWage?.toString();
      payload = {
        requestedWage: wageString ? (parseFloat(wageString) * 100).toFixed(2) : undefined,
        requestedStartTime: input.requestedStartTime || null,
        requestedEndTime: input.requestedEndTime || null,
        explanation: input.explanation?.trim() || null,
      };
      
    }

    // Send the payload to backend
    await createApplication(payload);
    
  } catch (error) {
    // Cast error to any for TypeScript safely
    const err = error as any;
    console.error("Error in onBidShift:", err);
    // The API returns its user-facing text in `data.error` (see BaseException on the
    // server, which serialises { error, statusCode }); `data.message` is only used by
    // class-validator responses. Check `error` first, or genuine messages like "This
    // location requires an active RB Pay profile…" get replaced by the raw axios
    // string "Request failed with status code 403".
    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong.";
    setErrorMessage(message);
  } finally {
    setIsSubmitting(false);
  }
};
  // createApplication New----

  const createApplication = async (input?: any) => {
  try {
    // --- Upload signature if newFile exists ---
    if (newFile) {
      await AuthService.updateWorker({ signature: newFile });
    }

    // --- Determine requestedRate for payload ---
    // If the caller provided an input payload (from the modal/form), prefer
    // sending that payload to the backend even when allowOffers === false.
    // This preserves the "preview/request" behavior and any owner/worker
    // side effects (color-coding, preview generation, etc.).
    let requestedRate = typeof input === "object" && input !== null ? input.requestedWage : input;
    if (requestedRate === 0 || requestedRate == null) {
      if (biddingRate != null) requestedRate = biddingRate;
    }

    setBiddingVisible(false);
    setIsSubmitting(true);

    // If the caller supplied a payload (requestedWage or start/end/explanation)
    // send it using the same request API used when allowOffers === true.
    const hasPayload = input && (input.requestedWage || input.requestedStartTime || input.requestedEndTime || input.explanation);

    // Keep Apply consistent with Search: if the worker searched with
    // "Ignore My Unavailable Days" enabled, the same unavailability override applies here.
    const ignoreWorkerUnavailability = getIgnoreWorkerUnavailability();

    if (hasPayload) {
      const payload: RequestedRatetDto = {
        // input may already contain requestedWage transformed by onBidShift
        requestedWage: input.requestedWage ?? requestedRate,
        requestedStartTime: input?.requestedStartTime || null,
        requestedEndTime: input?.requestedEndTime || null,
        explanation: input?.explanation?.trim() || null,
      };

      const response = await ShiftService.requestShiftWithSignatureAndRate(
        searchedShiftDetail.id,
        payload,
        ignoreWorkerUnavailability
      );
      console.log("response.  ", response);
    } else if (searchedShiftDetail.allowOffers) {
      // No explicit payload but allowOffers is true — keep existing behavior
      const payload: RequestedRatetDto = {
        requestedWage: requestedRate,
        requestedStartTime: input?.requestedStartTime || null,
        requestedEndTime: input?.requestedEndTime || null,
        explanation: input?.explanation?.trim() || null,
      };

      const response = await ShiftService.requestShiftWithSignatureAndRate(
        searchedShiftDetail.id,
        payload,
        ignoreWorkerUnavailability
      );
      console.log("response.  ", response);
    } else {
      // No payload and offers not allowed: plain apply
      await ShiftService.applyShiftById(searchedShiftDetail.id, ignoreWorkerUnavailability);
    }

    // --- Prepare dynamic employer name for alert ---
    const employerName =
      industryMode === IndustryModeEnum.Pharmaceutical
        ? "pharmacy"
        : industryMode === IndustryModeEnum.Dentistry
        ? "dental practice"
        : "company";
     
    setApplyAlertInfo({
      title: "Shift applied",
      message: `You will receive a notification if the ${employerName} chooses you. The shift will be removed from your ‘applied’ list if the ${employerName} chooses another applicant.
      \nIf you become unavailable for this shift, please withdraw your application in the shift details right away.`,
      buttons: [
        <RBButton
          key="confirm"
          onClick={async () => {
            setAlertShowing(false);
            history.goBack();
          }}
          buttonBackgroundColor={primaryColor}
          color="primary"
          text="Go Back"
        />,
      ],
    });

    setAlertShowing(true);

    // --- Publish shift change notification ---
    NotificationService.publish(
      NotificationServiceTopic.ShiftChanged,
      searchedShiftDetail.id
    );
  } catch (err) {
   // Cast inside catch
    const error = err as any;
    // `data.error` first — that is where the API puts its user-facing message (see the
    // note in onBidShift). Without it, a server rejection such as the RB Pay setup
    // check surfaces as "Request failed with status code 403".
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Unexpected error";

    if (message === "This shift has already started.") {
      setErrorMessage("This shift has already started.");
    } else {
      setErrorMessage(message);
    }

    setSubmitErrorMessage(message);
  } finally {
    setIsSubmitting(false);
  }
};

  const renderSearchedShiftDetailActions = () => {
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          alignItems: "flex-end",
        }}
      >
        <RBButton
          style={{
            display: "flex",
            flex: 1,
            padding: Spacing.medium,
            margin: Spacing.large,
          }}
          buttonBackgroundColor={primaryColor}
          onClick={() => guardApply(onSubmit)}
          isLoading={isSubmitting}
          disabled={!agreeTOS || account?.pharmacist?.approval?.approvalMode === ApprovalModeEnum.OnHold}
          text={`Total : $${totalEarning}  |  Apply`}
        />
      </div>
    );
  };
  const renderSearchShiftContent = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: Spacing.medium,
        }}
      >
        <pre>{JSON.stringify(searchedShiftDetail, null, 2)}</pre>
      </div>
    );
  };

  const onClose = () => {
    // goBackToPreviousLocation();
    history.goBack();
  };

  const onBidClose= () => {
    setwageRequest(originalWage);
    setwWgeDisplayValue("0");
    setBiddingVisible(false)
  };

  const isWageValidFn = (wage:any) => {
    if (!wage){
      return false;
    }
    const lowerBound = 1;
    const wageAmount = parseFloat(wage.replace('$', ''));
    const result = wageAmount >= lowerBound && isFinite(wageAmount);
    setIsWageValid(result);
    return result;
  };


  const renderRequestedRateContent = () => {

    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          > 
          <form>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: Spacing.large }}>
              <label htmlFor="shiftNumber" style={{ fontWeight: "bold", marginBottom: 6 }}>
                Shift Number
              </label>
              <input
                id="shiftNumber"
                readOnly
                value={searchedShiftDetail.shiftNumber}
                style={{
                  // match the hourly rate / other inputs: full width inside card, consistent padding & border
                  width: "100%",
                  boxSizing: "border-box",
                  padding: Spacing.medium,
                  borderRadius: 5,
                  fontSize: 16,
                  // fontWeight: "bold",
                  textAlign: "center",
                  // backgroundColor: "#e8f5e9",
                  border: `2px solid rgb(52, 175, 71)`,
                   color: "#6b6b6b", 
                   cursor: "not-allowed",
                   opacity: 1,
                  outline: "none",
                  maxWidth: 760, // optional cap to prevent excessive width on very large screens
                 
                }}
                aria-readonly
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                htmlFor="requestedRate"
                style={{ fontWeight: "bold", marginBottom: 4 }}
                 >
                Hourly Rate ($)
                 </label>
      
          {(() => {
            // when allowOffers === false the owner does not allow offers
            // make the rate field read-only (like the shift number input)
            const isRateEditable = searchedShiftDetail?.allowOffers !== false;

            return (
              <RBMoneyAmountTextFieldColor
                name="currency"
                value={formik.values.requestedRate}
                // only attach handlers when editable to avoid changing touched/error state
                onChange={isRateEditable
                  ? (event) => {
                      // mark that the user is editing the rate (avoids restoring while typing)
                      setLastFocusedField("rate");

                      const raw = event.target.value || "";
                      // strip everything except digits and dot
                      let cleaned = raw.replace(/[^0-9.]/g, "");
                      // collapse multiple dots (keep first)
                      const parts = cleaned.split(".");
                      if (parts.length > 2) {
                        cleaned = parts[0] + "." + parts.slice(1).join("");
                      }
                      // update formik + local state
                      formik.setFieldValue("requestedRate", cleaned === "" ? "" : cleaned, true);
                      setwageRequest(cleaned === "" ? "" : cleaned);
                      const wageAmount = parseFloat(cleaned);
                      const result = !isNaN(wageAmount) && isFinite(wageAmount) && wageAmount >= 1;
                      setIsWageValid(result);
                      // DO NOT clear lastFocusedField here — keep it "rate" while user is typing
                    }
                  : undefined}
                onFocus={isRateEditable
                  ? () => {
                      setRateFocused(true);
                      setLastFocusedField("rate");
                    }
                  : undefined}
                onBlur={isRateEditable
                  ? () => {
                      setRateFocused(false);
                      // leave lastFocusedField as "rate" so effect waits for other-field interaction
                      setLastFocusedField("rate");
                      // mark field as touched so Formik will show errors
                      formik.setFieldTouched("requestedRate", true, true);

                      // validate and show custom error message if empty/zero/invalid
                      const rawVal = formik.values.requestedRate ?? "";
                      const num = parseFloat(rawVal.toString());
                      const invalid = rawVal === "" || isNaN(num) || num <= 0;
                      if (invalid) {
                        formik.setFieldError("requestedRate", "Please enter valid wage");
                        setIsWageValid(false);
                      } else {
                        formik.setFieldError("requestedRate", undefined);
                        setIsWageValid(true);
                      }
                    }
                  : undefined}
                isChanged={fieldChangeStatus.rateChanged}
                readOnly={!isRateEditable}
                style={
                  !isRateEditable
                    ? { cursor: "not-allowed", color: "#6b6b6b"}
                    : undefined
                }
              />
            );
          })()}
          {formik.touched.requestedRate && formik.errors.requestedRate && (
  <div style={{ color: "red", fontSize: "12px" }}>
    {formik.errors.requestedRate}
  </div>
)}
           </div>
           <br></br>

           <div style={{
            display: "flex",
            flex: 1,
            alignItems: "flex-start",
             justifyContent: "space-between"
          }}>


               <div style={{ display: "flex", flexDirection: "column" }}>
                 <label
                htmlFor="startDate"
                style={{ fontWeight: "bold", marginBottom: 4 }}
                 >
                Requested Start Time
                 </label>
              <DatePicker
                selected={selectedStartDate}
                onChange={(date) => {
                  setLastFocusedField("start");
                  setSelectedStartDate(date)
                  console.log("StartDate  structure from datepicker",date)

                  if(!date) return;
                  // Interpret the picked Date as the shift's local wall time (use dynamic timezone)
                  const datePickerStartTorontoMoment = moment.tz(
                    moment(date).format("YYYY-MM-DD HH:mm:ss"),
                    shiftTimeZone
                  );
                  // converting torontotime into utc
                  const utcStarttimeMoment=datePickerStartTorontoMoment.clone().utc()
                  console.log(" 🔴Toronto localtime shiftStartTime======>",datePickerStartTorontoMoment.format())
                  console.log("🔴utc to send to backend ShiftStartTime by default ========>",utcStarttimeMoment.format())
                  formik.setFieldValue("requestedStartTime",utcStarttimeMoment.format() )

                  // const utcStart = timezoneDateToUtc(date, shiftTimeZone);
                  // console.log("🔴utc to send to backend ShiftStartTime By new========>", utcStart);
                  // // formik.setFieldValue("requestedStartTime", utcStart);
                }}
                showTimeSelect

                minDate={ origStartTorontoMoment ?new Date(
                       origStartTorontoMoment.year(),
                       origStartTorontoMoment.month(),
                       origStartTorontoMoment.date(),
                       origStartTorontoMoment.hour(),
                       origStartTorontoMoment.minute()
                      
                         ): undefined}
               maxDate={ maxStartTorontoMoment ? new Date(
                       maxStartTorontoMoment.year(),
                       maxStartTorontoMoment.month(),
                      maxStartTorontoMoment.date(),
                       maxStartTorontoMoment.hour(),
                       maxStartTorontoMoment.minute()
  
                      ): undefined}
                     {...({ filterTime:  filterStartTimes } as any)} 
              
                timeFormat="h:mm aa"
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="eee, MMM do yyyy h:mm aa"
                customInput={
                //  customInput={<input style={datePickerStyle(!!formik.errors.requestedStartTime)} />}
                  <input
                    id="startDate"
                    style={{
                      boxSizing: 'border-box',
                      paddingTop: Spacing.medium,
                      paddingBottom: Spacing.medium,
                      paddingRight: 40,
                      borderRadius:5,
                      // borderColor:"rgb(220 220 220)",
                      width: 260,
                      fontSize:15,
                      ...getBorderStyle(fieldChangeStatus.startChanged),
                    }}
                    key={`dateTime-start`}
                  />
                }
                withPortal
                
              />
              
                {startDateError && (
                  <div style={{ color: "red", fontSize: 12 }}>{startDateError}</div>
                )}
                
             <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        textAlign: "start",
                        fontSize: 12,
                        color:"grey"
                      }}
                    >
                      *Start time can be pushed up to 4 hours later than the original start.
                    </div>
            </div>
            <RBEmptyBlock/>
               
               <div style={{ display: "flex", flexDirection: "column" }}>
                 <label
                   htmlFor="endDate"
                    style={{ fontWeight: "bold", marginBottom: 4 }}
                    >
                Requested End Time
                </label>
               
               <DatePicker
                selected={selecteEndtDate}
                onChange={(date) => {
                  setLastFocusedField("end");
                  setSelectedEndtDate(date)
                  if(!date) return;
                  // Interpret the picked Date as the shift's local wall time (use dynamic timezone)
                  const datePickerEndTorontoMoment = moment.tz(
                    moment(date).format("YYYY-MM-DD HH:mm:ss"),
                    shiftTimeZone
                  )
                  // converting torontotime into utc
                  const utcEndtimeMoment=datePickerEndTorontoMoment.clone().utc()
                  console.log("🔴Toronto localtime ShiftEndTime ======>",datePickerEndTorontoMoment.format())
                  console.log("🔴utc to send to backend ShiftEndTime=======>",utcEndtimeMoment.format())
                  formik.setFieldValue("requestedEndTime", utcEndtimeMoment.format())


                    


                }}
                showTimeSelect

                minDate={minEndTorontoMoment ?new Date(
                  minEndTorontoMoment.year(),
                  minEndTorontoMoment.month(),
                  minEndTorontoMoment.date(),
                  minEndTorontoMoment.hour(),
                  minEndTorontoMoment.minute()
                  ): undefined}
               maxDate={origEndTorontoMoment ? new Date(
                 origEndTorontoMoment.year(),
                 origEndTorontoMoment.month(),
                 origEndTorontoMoment.date(),
                 origEndTorontoMoment.hour(),
                 origEndTorontoMoment.minute()
                  ) : undefined}
               
                {...({ filterTime: filterEndTimes } as any)}
                
                timeFormat="h:mm aa"
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="eee, MMM do yyyy h:mm aa"
                customInput={
                  <input
                   id="endDate"
                    style={{
                      boxSizing: 'border-box',
                      paddingTop: Spacing.medium,
                      paddingBottom: Spacing.medium,
                      paddingRight: 40,
                      borderRadius:5,
                      // borderColor:"rgb(220 220 220)",
                      width: 260,
                      fontSize:15,
                      ...getBorderStyle(fieldChangeStatus.endChanged),
                    }}
                    key={`dateTime-end`}
                  />
                }
                withPortal
                
              />
             
               {endDateError && (
                 <div style={{ color: "red", fontSize: 12 }}>{endDateError}</div>
               ) }
             


                       <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        textAlign: "start",
                        fontSize: 12,
                        color:"grey"
                      }}
                    >
                     *End time can be pulled up to 4 hours earlier than the original end.
                    </div>
              </div>

              
           </div>
           

            <label
            htmlFor="explanation"
            style={{
              fontWeight: "bold",
              display: "block",        // ensures label sits directly above field
              marginBottom: 6, 
              marginTop: Spacing.large,       // small gap only
              lineHeight: "1.15",
            }}
          >
          Brief Explanation for the Request
          </label>
            <RBTextFieldColor
                     style={{
                       display: "flex",
                       flex: 1,
                       paddingTop: Spacing.small,
                       paddingBottom: Spacing.small,
                       marginTop: Spacing.smallest, 
                     }}
                     placeholder={"Please share any additional details about your reason for the change(s).(Request with details get accepted more often)"}
                     value={formik.values.explanation}
                     onChange={(e)=> {
                      const value = e.target.value.slice(0,250);
                      // const sanitized = maskSensitiveInfo(value);
                      
                      // formik.setFieldValue("explanation",sanitized);
                      formik.setFieldValue("explanation",value);
                     }}

                      onFocus={() => {
                        setLastFocusedField("explanation");
        
                      }}

                     
                     multiline
                     rows={3}
                     rowsMax={8}
                     inputProps={{ maxLength: 250 }}
                     isChanged={fieldChangeStatus.explanationChanged}
                   />
                  {/* Character count for explanation (max 250) */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 6,
                      fontSize: 12,
                      color: "#6b6b6b",
                    }}
                  >
                    {(formik.values.explanation || "").length}/250
                  </div>
                 
           
           
           <div style={{
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
          }}>

           
            



 

                <RBButton
                // type="submit"
                  buttonBackgroundColor={primaryColor}
                  // disabled={!isChanged}
                   // disable if nothing changed or the form is invalid (empty/negative/zero)
                   disabled={!isChanged || !formik.isValid || !isDateTimeValid}
                  isLoading={isSubmitting}
                  text="Apply"
                  onClick={()=>formik.handleSubmit()}
                  
                  style={{
                    display: "flex",
                    flex: 1,
                    padding: Spacing.medium,
                    margin: Spacing.large,
                  }}
                />
                <RBButton
                  buttonBackgroundColor={primaryColor}
                  text="Cancel"
                  onClick={() => {
                    setwageRequest(originalWage);
                    setwWgeDisplayValue("0");
                    setBiddingVisible(false);
                    }
                  }
                  style={{
                    display: "flex",
                    flex: 1,
                    padding: Spacing.medium,
                    margin: Spacing.large,
                  }}
                />
           </div>
          </form>
          </RBCardView>
       
      </div>
    );
  };
  const rendersignatureContent = () => {

    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,
          userSelect:"none",
          pointerEvents:"none"

        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            <PDFViewer pdfUrl={defaultSignature} title="signature"></PDFViewer>
          </RBCardView>
       
      </div>
    );
  };

  const goBackToPreviousLocation = () => {
    if (location.state && location.state.background) {
      setShowModal(false);
      history.goBack();
    } else {
      setShowModal(false);
      history.push("/dashboard");
    }
  };
  return (
    <>
      {/* <RBAlert
            show={isDiscardAlertShowing}
            alertTitle={discardAlertSInfo.title}
            alertMessage={discardAlertSInfo.message}
            buttons={discardAlertSInfo.buttons}
          /> */}
      <RBErrorAlert
        show={submitErrorMessage ? true : false}
        errorMessage={errorMessage}
        onClose={() => {
          setSubmitErrorMessage(undefined);
        }}
      />
      <RBPaySetupRequiredModal
        open={rbPayGateOpen}
        variant={rbPayGate.modal}
        contactEmail={rbPayGate.contactEmail}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        onClose={() => setRbPayGateOpen(false)}
        onSetup={goToRBPaySetup}
      />
      <RBModal
          open={resumeModal}
          onClose={onResumeClose}
          modalTitle={"Signature"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
         // actions={this.renderCreateShiftActions()}
          children={
              rendersignatureContent()
          }
        />



        <RBModal
          open={biddingVisible}
          onClose={onBidClose}
          modalTitle={"Request Change"
          }
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
         // actions={this.renderCreateShiftActions()}
          children={
            <>
             { renderRequestedRateContent()}
            
            </>
          }
        />

      <RBModal
        backArrowIcon
        open={showModal}
        onClose={onClose}
        modalTitle={
          //   currentCreateShiftState === CreateShiftState.Create
          //     ? "Create Shift"
          //     : "Preview Shift"
          "Shift Details"
        }
        header={
          <RBEmptyBlock
            style={{
              width: "100%",
              height: Spacing.large,
              backgroundColor: Colors.defaultGrey,
              flexShrink: 0,
            }}
          />
        }
       // actions={!isLoading && renderSearchedShiftDetailActions()}
        children={
          isLoading ? <LoadingIndicator /> : renderSearchedShiftDetail()
        }
      />
    </>
  );
};

export const ApplyShiftPage = withRouter(ApplyShiftPageWithoutRouter);
